import logger from 'utils/logger';

let didImport = false;

export const initGTM = () => {
  if (didImport) {
    return Promise.resolve();
  }
  didImport = true;
  return import('./init')
    .then(({ initGoogleTagManager }) => {
      initGoogleTagManager();
    })
    .catch(error => {
      didImport = false;
      logger.error({ error, message: 'Google Tag Manager: import error' });
    });
};
